// V28 — SSO URL safety helper.
// Mirrors the website team's pattern (PDF "Website to OPS" §4.1) for thank-you
// pages: read sessionStorage first (set by the synchronous <head> script
// before any tracker fires), fall back to URL params for backward compatibility.
//
// Why: PostHog session recording + future Meta Pixel mounting on OPS thank-you
// pages would otherwise capture one-time SSO tokens in their pageview URLs.
// The <head> script in public/index.html strips ?sso= before trackers run.

const SSO_PATHS = ['/trial-thank-you', '/garbhsanskar-full/thank-you'];

/**
 * Read a query-style param, preferring sessionStorage.purchase_tracking
 * (populated by the head-script) over URL params.
 *
 * @param {URLSearchParams} searchParams - react-router useSearchParams instance
 * @param {string} key - param name (e.g. 'sso', 'welcome_kind')
 * @returns {string|null}
 */
export const getSafeSsoParam = (searchParams, key) => {
  // 1. Try sessionStorage (set by inline head-script before any tracker fires)
  try {
    const raw = window.sessionStorage.getItem('purchase_tracking');
    if (raw) {
      const data = JSON.parse(raw);
      // Map URL-param names to the storage shape
      const aliasMap = {
        sso: 'ssoUrl',
        welcome_kind: 'welcomeKind',
        sso_expires_at: 'ssoExpiresAt',
      };
      const storageKey = aliasMap[key] || key;
      if (data && data[storageKey]) return data[storageKey];
    }
  } catch (_e) {
    /* sessionStorage unavailable (private browsing); fall through */
  }
  // 2. URL param fallback (for backward compat or if head-script didn't run)
  return searchParams.get(key);
};

/**
 * Returns true if the current pathname is one we strip ?sso= from.
 * Exposed for testing the head-script gate logic from React land.
 */
export const isSsoSafePath = (pathname) => SSO_PATHS.includes(pathname);
